/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { HealthReport } from '../models/health-report';
@Injectable({
  providedIn: 'root',
})
class LegacyHealthService extends __BaseService {
  static readonly LegacyHealthPostPath = '/{customer}';
  static readonly LegacyHealthHealthPath = '/{customer}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `LegacyHealthService.LegacyHealthPostParams` containing the following parameters:
   *
   * - `value`:
   *
   * - `customer`:
   */
  LegacyHealthPostResponse(params: LegacyHealthService.LegacyHealthPostParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.value;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/${encodeURIComponent(String(params.customer))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `LegacyHealthService.LegacyHealthPostParams` containing the following parameters:
   *
   * - `value`:
   *
   * - `customer`:
   */
  LegacyHealthPost(params: LegacyHealthService.LegacyHealthPostParams): __Observable<Blob> {
    return this.LegacyHealthPostResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param customer undefined
   */
  LegacyHealthHealthResponse(customer: string): __Observable<__StrictHttpResponse<HealthReport>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/${encodeURIComponent(String(customer))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<HealthReport>;
      })
    );
  }
  /**
   * @param customer undefined
   */
  LegacyHealthHealth(customer: string): __Observable<HealthReport> {
    return this.LegacyHealthHealthResponse(customer).pipe(
      __map(_r => _r.body as HealthReport)
    );
  }
}

module LegacyHealthService {

  /**
   * Parameters for LegacyHealthPost
   */
  export interface LegacyHealthPostParams {
    value: string;
    customer: string;
  }
}

export { LegacyHealthService }
